import React from "react";
import SidebarContent from "./../layout/SidebarContent";

type Props = {
  onToggle: () => void;
};

const SidebarCollapsed: React.FC<Props> = ({ onToggle }) => {
  return (
    <aside className="fixed top-0 left-0 h-full w-14 bg-gray-50 border-r">
      <SidebarContent variant="collapsed" onToggle={onToggle} />
    </aside>
  );
};

export default SidebarCollapsed;